import { inject, Injectable } from '@angular/core';
import {
  ProductServoPipelineResultDto,
  PublicServoKaufpreisKaskoApiService,
  PublicServoKaufpreisKaskoContractCreateDto,
  ServoKaufpreisKaskoVersicherungspraemieCalcDto
} from '@base/backend';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KaufpreisService {
  private readonly publicServoKaufpreisKaskoApiService = inject(PublicServoKaufpreisKaskoApiService);

  public getPremium(price: number): Observable<number | null> {
    const dto: ServoKaufpreisKaskoVersicherungspraemieCalcDto = {
      kaufpreisInEur: price
    };

    return this.publicServoKaufpreisKaskoApiService.apiPublicServoKaufpreisKaskoContractKaufpreiskaskoVersicherungspraemiePost(dto).pipe(
      map(calculationResult => calculationResult.versicherungspraemieInEur || null),
      catchError(() => {
        return of(null);
      })
    );
  }

  submitKaufpreisContract(dto: PublicServoKaufpreisKaskoContractCreateDto): Observable<ProductServoPipelineResultDto> {
    return this.publicServoKaufpreisKaskoApiService
      .apiPublicServoKaufpreisKaskoContractKaufpreiskaskoPost(dto);
  }
}
